import React from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/management/edit.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { IDiscount } from "../../types/discount.type";
import styles from "./styles.module.scss";

interface Props {
  discounts: IDiscount[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (user: IDiscount) => void;
}

const DiscountTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Відсоток (%)</th>
          <th>Кількість товарів</th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.discounts &&
          props.discounts.map((user, index) => (
            <tr key={user.id}>
              <td>
                <div className={styles.userInfo}>
                  <div className={styles.nameContainer}>
                    <span className={styles.name}>{user.percent}</span>
                  </div>
                </div>
              </td>

              <td className={styles.role}>{user.products.length}</td>
              <td>
                <div className={styles.actions}>
                  <button
                    className={styles.editBtn}
                    onClick={() => {
                      props.callBackInfo(false);
                      props.callBackEdit(user);
                    }}
                  >
                    <EditIcon />
                  </button>
                  <button
                    className={styles.infoBtn}
                    onClick={() => {
                      props.callBackInfo(true);
                      props.callBackEdit(user);
                    }}
                  >
                    <InfoIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default DiscountTable;
